import styled from "styled-components";
import { theme } from "../../../theme";

const ActiveFieldWrapper = styled.div<{ $active: boolean }>`
  border-radius: 4px;
  outline: ${({ $active }) =>
    $active ? `2px solid ${theme.colors.primary}` : "none"};
  cursor: pointer;
  flex: 1;
  min-width: 0;
  padding-top: -2px;
`;

export default ActiveFieldWrapper;
